import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import HomeMobile from '../views/HomeMobile.vue'
import TeacherLogin from '../views/TeacherLogin.vue'
import TeacherRegister from '../views/TeacherRegister.vue'
import LoginMobile from '../views/LoginMobile.vue'
import SigninMobile from '../views/SigninMobile.vue'
import JoinClass from '../views/JoinClass.vue'
import JoinClassMobile from '../views/JoinClassMobile.vue'
import NewClass from '../views/NewClass.vue'
import NewClassMobile from '../views/NewClassMobile.vue'
import BindTeacher from '../views/BindTeacher.vue'
import BindTeacherMobile from '../views/BindTeacherMobile.vue'
import HomeRedirect from '../views/HomeRedirect.vue'
import MobileClassSelector from '../views/MobileClassSelector.vue'
import DesktopClassSelector from '../views/DesktopClassSelector.vue'
import MoreMobile from '../views/MoreMobile.vue'
import ManagementMobile from '../views/ManagementMobile.vue'
import RollCallMobile from '../views/RollCallMobile.vue'
import PenaltyFreeMobile from '../views/PenaltyFreeMobile.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'HomeRedirect',
    component: HomeRedirect
  },
  {
    path: '/mobile',
    name: 'MobileClassSelector',
    component: MobileClassSelector,
    meta: { requiresAuth: true }
  },
  {
    path: '/desktop',
    name: 'DesktopClassSelector',
    component: DesktopClassSelector,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'TeacherLogin',
    component: TeacherLogin
  },
  {
    path: '/signin',
    name: 'TeacherRegister',
    component: TeacherRegister
  },
  {
    path: '/joinclass',
    name: 'JoinClass',
    component: JoinClass,
    meta: { requiresAuth: true, keepRedirect: true }
  },
  {
    path: '/joinclassmobile',
    name: 'JoinClassMobile',
    component: JoinClassMobile,
    meta: { requiresAuth: true, keepRedirect: true }
  },
  {
    path: '/newclass',
    name: 'NewClass',
    component: NewClass,
    meta: { requiresAuth: true, keepRedirect: true }
  },
  {
    path: '/newclassmobile',
    name: 'NewClassMobile',
    component: NewClassMobile,
    meta: { requiresAuth: true, keepRedirect: true }
  },
  {
    path: '/class/:classId',
    name: 'ClassHome',
    component: Home,
    props: true
  },
  {
    path: '/mobile/class/:classId',
    name: 'MobileClassHome',
    component: HomeMobile,
    props: true
  },
  {
    path: '/mobile/more/:classId',
    name: 'MobileMore',
    component: MoreMobile,
    props: true
  },
  {
    path: '/mobile/management/:classId',
    name: 'MobileManagement',
    component: ManagementMobile,
    props: true
  },
  {
    path: '/mobile/rollcall/:classId',
    name: 'MobileRollCall',
    component: RollCallMobile,
    props: true
  },
  {
    path: '/mobile/penalty/:classId',
    name: 'MobilePenaltyFree',
    component: PenaltyFreeMobile,
    props: true
  },
  {
    path: '/bindteacher',
    name: 'BindTeacher',
    component: BindTeacher,
    meta: { requiresAuth: true, keepRedirect: true }
  },
  {
    path: '/bindteachermobile',
    name: 'BindTeacherMobile',
    component: BindTeacherMobile,
    meta: { requiresAuth: true, keepRedirect: true }
  },
  {
    path: '/loginmobile',
    name: 'LoginMobile',
    component: LoginMobile
  },
  {
    path: '/signinmobile',
    name: 'SigninMobile',
    component: SigninMobile
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes
})

const pcToMobileRoutes = {
  '/class/:classId': '/mobile/class/:classId',
  '/desktop': '/mobile',
  '/login': '/loginmobile',
  '/signin': '/signinmobile',
  '/joinclass': '/joinclassmobile',
  '/newclass': '/newclassmobile',
  '/bindteacher': '/bindteachermobile'
}

const mobileToPcRoutes = {
  '/mobile/class/:classId': '/class/:classId',
  '/mobile/more/:classId': '/desktop',
  '/mobile/management/:classId': '/desktop',
  '/mobile/rollcall/:classId': '/desktop',
  '/mobile/penalty/:classId': '/desktop',
  '/mobile': '/desktop',
  '/loginmobile': '/login',
  '/signinmobile': '/signin',
  '/joinclassmobile': '/joinclass',
  '/newclassmobile': '/newclass',
  '/bindteachermobile': '/bindteacher'
}

function isMobileDevice() {
  return window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

function isPcDevice() {
  return !isMobileDevice();
}

function convertPcToMobilePath(pcPath, params) {
  for (const pcRoute in pcToMobileRoutes) {
    const mobileRoute = pcToMobileRoutes[pcRoute];
    
    const pcRouteParts = pcRoute.split('/');
    const pathParts = pcPath.split('/');
    
    let isMatch = true;
    let mobilePath = mobileRoute;
    
    for (let i = 0; i < pcRouteParts.length; i++) {
      if (pcRouteParts[i].startsWith(':')) {
        const paramName = pcRouteParts[i].substring(1);
        const paramValue = pathParts[i];
        if (paramValue) {
          mobilePath = mobilePath.replace(`:${paramName}`, paramValue);
        }
      } else if (pcRouteParts[i] !== pathParts[i]) {
        isMatch = false;
        break;
      }
    }
    
    if (isMatch && pathParts.length === pcRouteParts.length) {
      return mobilePath;
    }
  }
  return null;
}

function convertMobileToPcPath(mobilePath, params) {
  for (const mobileRoute in mobileToPcRoutes) {
    const pcRoute = mobileToPcRoutes[mobileRoute];
    
    const mobileRouteParts = mobileRoute.split('/');
    const pathParts = mobilePath.split('/');
    
    let isMatch = true;
    let pcPath = pcRoute;
    
    for (let i = 0; i < mobileRouteParts.length; i++) {
      if (mobileRouteParts[i].startsWith(':')) {
        const paramName = mobileRouteParts[i].substring(1);
        const paramValue = pathParts[i];
        if (paramValue) {
          pcPath = pcPath.replace(`:${paramName}`, paramValue);
        }
      } else if (mobileRouteParts[i] !== pathParts[i]) {
        isMatch = false;
        break;
      }
    }
    
    if (isMatch && pathParts.length === mobileRouteParts.length) {
      return pcPath;
    }
  }
  return null;
}

function isMobilePath(path) {
  return Object.keys(mobileToPcRoutes).some(mobileRoute => {
    const routeParts = mobileRoute.split('/');
    const pathParts = path.split('/');
    
    if (routeParts.length !== pathParts.length) {
      return false;
    }
    
    for (let i = 0; i < routeParts.length; i++) {
      if (routeParts[i].startsWith(':')) {
        continue;
      }
      if (routeParts[i] !== pathParts[i]) {
        return false;
      }
    }
    
    return true;
  });
}

function isPcPath(path) {
  return Object.keys(pcToMobileRoutes).some(pcRoute => {
    const routeParts = pcRoute.split('/');
    const pathParts = path.split('/');
    
    if (routeParts.length !== pathParts.length) {
      return false;
    }
    
    for (let i = 0; i < routeParts.length; i++) {
      if (routeParts[i].startsWith(':')) {
        continue;
      }
      if (routeParts[i] !== pathParts[i]) {
        return false;
      }
    }
    
    return true;
  });
}

router.beforeEach((to, from, next) => {
  if (isMobileDevice() && isPcPath(to.path)) {
    const mobilePath = convertPcToMobilePath(to.path, to.params);
    if (mobilePath) {
      const query = to.query ? { ...to.query } : {};
      window.location.href = mobilePath + (Object.keys(query).length > 0 ? '?' + new URLSearchParams(query).toString() : '');
      return;
    }
  }
  
  if (isPcDevice() && isMobilePath(to.path)) {
    const pcPath = convertMobileToPcPath(to.path, to.params);
    if (pcPath) {
      const query = to.query ? { ...to.query } : {};
      window.location.href = pcPath + (Object.keys(query).length > 0 ? '?' + new URLSearchParams(query).toString() : '');
      return;
    }
  }
  
  if (to.meta.requiresAuth) {
    const teacherInfo = localStorage.getItem('teacherInfo');
    
    if (!teacherInfo) {
      console.log('未登录，重定向到登录页面');
      const loginPath = to.path.startsWith('/mobile') ? '/loginmobile' : '/login';
      
      const redirectQuery = to.meta.keepRedirect ? { redirect: to.fullPath } : {};
      
      next({
        path: loginPath,
        query: redirectQuery
      });
      return;
    }
    
    try {
      const parsedInfo = JSON.parse(teacherInfo);
      if (!parsedInfo.id) {
        throw new Error('教师信息不完整');
      }
    } catch (error) {
      console.error('教师信息验证失败:', error);
      localStorage.removeItem('teacherInfo');
      const loginPath = to.path.startsWith('/mobile') ? '/loginmobile' : '/login';
      
      const redirectQuery = to.meta.keepRedirect ? { redirect: to.fullPath } : {};
      
      next({
        path: loginPath,
        query: redirectQuery
      });
      return;
    }
  }
  
  next();
});

export default router
